import {
    Component,
    ViewEncapsulation,
    Injector,
    ViewChild,
    OnInit,
} from "@angular/core";
import { appModuleAnimation } from "@shared/animations/routerTransition";
import { AppComponentBase } from "@shared/common/app-component-base";
import {
    EventsServiceProxy,
    EventTypesServiceProxy,
    EventTypeListDto,
    OrdersServiceProxy,
    PaymentChargesServiceProxy,
    EntityDtoOfInt64,
} from "@shared/service-proxies/service-proxies";
import { LazyLoadEvent } from "primeng/components/common/lazyloadevent";
import { Paginator } from "primeng/components/paginator/paginator";
import { DataTable } from "primeng/components/datatable/datatable";
import { EventInformationsModalComponent } from "@app/event/event-informations-modal/event-informations-modal.component";
//import { GoogleTagManagerService } from 'angular-google-tag-manager';

import * as _ from "lodash";
import { ActivatedRoute, Params, Router, NavigationEnd } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { CartHelperService } from "@app/store/cart/cart-helper-service";
import { filter } from "rxjs/operators";
import { LoginService } from "account/login/login.service";

declare var gtag;

@Component({
    templateUrl: "./sign-up.component.html",
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
})
export class SignUpComponent extends AppComponentBase {
    @ViewChild("eventInformationsModal")
    eventInformationsModal: EventInformationsModalComponent;
    @ViewChild("dataTable") dataTable: DataTable;
    @ViewChild("paginator") paginator: Paginator;

    //Filters
    filterText = "";
    filterEventType = undefined;
    filterOnlyWithPlacesAvailable = undefined;
    filterOnlyWithOpenRegistrations = undefined;
    advancedFiltersAreShown = false;

    userId = undefined;

    events = [];
    types = [];
    subscriptions = [];
    iphone = false;

    externalAccessToken = "";
    onLocal = false;
    isAdmin = false;
    orderId = 0;
    success = false;
    filterTypeParam: string = undefined;

    constructor(
        injector: Injector,
        private activatedRoute: ActivatedRoute,
        private _eventsService: EventsServiceProxy,
        private _eventTypesService: EventTypesServiceProxy,
        private _cartHelperService: CartHelperService,
        private _paymentChargesService: PaymentChargesServiceProxy,
        private _ordersService: OrdersServiceProxy,
        private _router: Router,
        public _loginService: LoginService,
    ) //private gtmService: GoogleTagManagerService,
    {
        super(injector);

        // const navEndEvent$ = this._router.events.pipe(
        //   filter(e => e instanceof NavigationEnd)
        // );
        // navEndEvent$.subscribe((e: NavigationEnd) => {
        //   gtag('config', 'UA-79268901-1', {'page_path':e.urlAfterRedirects});
        // });
    }

    ngOnInit(): void {
        this.isAdmin = this.isGrantedAny(
            "Pages.Events.Registrations.Management",
            "Pages.Events.Registrations.RegistrationOnLocal"
        );
        // push GTM data layer for every visited page
        // this._router.events.forEach(item => {
        //   if (item instanceof NavigationEnd) {
        //     const gtmTag = {
        //       event: 'page',
        //       pageName: item.url
        //     };

        //     this.gtmService.pushTag(gtmTag);
        //   }
        // });

        this.iphone = this.isIphone();

        this.activatedRoute.params.subscribe((params: Params) => {
            this.onLocal = params["onLocal"] == "true" && this.isAdmin;
            this.orderId = !!params["orderId"] ? +params["orderId"] : 0;
            this.success = params["success"] == "true";
            this.externalAccessToken = params["token"];
            this.filterTypeParam =
                params["onLocal"] != "true" && params["onLocal"] != "false"
                    ? params["onLocal"]
                    : undefined; //TODO: Criar param type
        });

        // if (!this.externalAccessToken)
        //     this.externalAccessToken = this.activatedRoute.snapshot.queryParams['token'];

        // if (this.externalAccessToken && !this.appSession.userId) {
        //     this.login();
        // }
        // else {
            this.checkCart();
            this.getEvents();
        // }
    }

    //Login with token
    // login(): void {
    //     this.loading = true;
    //     this._loginService.authenticateModel.userNameOrEmailAddress = "login"; //UserName genérico
    //     this._loginService.authenticateModel.token = this.externalAccessToken;
    //     this._loginService.authenticateModel.password = "congress2023"; //Senha para login sem password
    //     this._loginService.authenticateModel.refererUrl = window.location.href;
    //     this._loginService.authenticate(() => {
    //         this.loading = false;
    //         this.checkCart();
    //         this.getEvents();
    //     });
    // }

    getEvents() {
        this.block(".m-portlet.m-portlet--full-height");

        this._eventsService
            .getEventsForSignUp(
                this.filterText,
                this.filterOnlyWithPlacesAvailable,
                this.filterOnlyWithOpenRegistrations,
                this.filterEventType
                    ? this.filterEventType
                    : this.filterTypeParam,
                this.userId,
                this.onLocal,
                false,
                undefined,
                undefined,
                undefined,
                undefined
            )
            .finally(() => {
                this.unBlock(".m-portlet.m-portlet--full-height");
            })
            .subscribe((result) => {
                this.subscriptions = result.items;

                if (this.types.length == 0) {
                    this.types = result.eventTypes;
                } else {
                    this.checkEventTypes(result.eventTypes);
                }
            });
    }

    // Add news items to the Type List
    checkEventTypes(eventTypes: string[]) {
        eventTypes.forEach((x) => {
            if (_.filter(this.types, (t) => t == x).length == 0) {
                this.types.push(x);
            }
        });
    }

    checkFilterParam(type: string) {
        return (
            this.filterTypeParam &&
            this.filterTypeParam.toLocaleLowerCase() == type.toLocaleLowerCase()
        );
    }

    clear(): void {
        this.filterText = "";
        this.filterEventType = undefined;
        this.filterOnlyWithPlacesAvailable = undefined;
        this.filterOnlyWithOpenRegistrations = undefined;
    }

    // Get Types
    filterTypes(event): void {
        this._eventTypesService
            .getEventTypesForSelect(event.query)
            .subscribe((result) => {
                this.types = result.items;
            });
    }

    /// Picture
    getEventPicture(eventPictureId: string): string {
        ///assets/common/images/user_profile_bg.png
        let eventPicture = "/assets/common/images/default-profile-picture.png";

        if (eventPictureId) {
            this._eventsService
                .getEventImageById(eventPictureId)
                .subscribe((result) => {
                    if (result && result.eventImage) {
                        eventPicture =
                            "data:image/jpeg;base64," + result.eventImage;
                    }

                    return eventPicture;
                });
        } else {
            return eventPicture;
        }
    }

    checkCart(): void {
        if (this.orderId > 0) {
            if (this.success) {
                let input = new EntityDtoOfInt64();
                input.id = this.orderId;

                this._paymentChargesService
                    .finishPayment(input)
                    .subscribe(() => {
                        this._cartHelperService.finalizeCart();

                        this.message.success(
                            this.l("Order successfully registered.")
                        );
                        this._ordersService
                            .sendConfirmPaymentEmail(input)
                            .subscribe((result) => { });
                        this._router.navigate(["app/event/signUp"]);
                    });
            } else {
                this._cartHelperService.finalizeCart();
                this.message.warn(this.l("Denied Transaction."));
                this._router.navigate(["app/financial/payment"], {
                    queryParams: {
                        receivableId: this.orderId,
                    },
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/event/sign-up/sign-up.component.ts